import React from "react";
import BannerImage from "../../BannerImage/BannerImage";
import { useDatasources, useStoryblokSlug } from "../../../contexts/StoryblokContext/StoryblokContext";
import { resolveAsset } from "../../../Common/scaleflex";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface BannerProps {}

const Banner: React.FC<BannerProps> = () => {
  const { activeLanguage } = useDatasources();
  const bannerStory = useStoryblokSlug("payment-summary-banner", activeLanguage);
  // Prefer the Scaleflex background when set, falling back to the native asset.
  const banner = bannerStory?.content?.blocks?.[0];
  const bannerImageSrc = resolveAsset(banner?.backgroundImageScaleflex, banner?.backgroundImage).src;

  return (
    <div className="flex h-banner w-full flex-col">
      <div className="absolute w-full">{bannerStory?.content && <BannerImage url={bannerImageSrc} size="base" />}</div>
    </div>
  );
};

export default Banner;
